const createImage = (): HTMLImageElement => new Image();

export default createImage;
